import { setTerm } from './helpers';

export const setAccessSystem = setTerm('enter');
